export default {
  featuredApps: [
    'seonghapark/cloud-cover',
    'seonghapark/traffic-state',
    'seonghapark/solar-irradiance',
    'seonghapark/motion-analysis',
    'seonghapark/surface-water-detection',
    'seonghapark/motion-detector',
    'seonghapark/water-depth-estimator',
    'seonghapark/surface-water-classifier',
    'yonghokim/object-counter',
    'bhupendraraut/cloud-motion',
    'rjackson/weather-classification',
    'dariodematties/avian-diversity-monitoring',
    'dariodematties/sound-event-detection',
    'iperezx/wildfire-smoke-detection'
  ],
  samplers: [
    'theone/imagesampler',
    'theone/video-sampler',
    'seanshahkarami/audio-sampler',
    'seanshahkarami/air-quality',
    'bhupendraraut/mobotix-scan',
    'bhupendraraut/mobotix-sampler',
    'flozano/lorawan-listener'
  ],
  plugins: [
    'seanshahkarami/plugin-iio',
    'seanshahkarami/raingauge',
  ]
}